import { COMMON, ifyouApi, kevinAuthAPI, STORY } from 'apis/config';

export const nameTagApi = {
  read: (projectId) =>
    ifyouApi.get(`${STORY}/${projectId}/nametag`).then((res) => res.data),
  update: (projectId, rows) =>
    ifyouApi
      .post(`${STORY}/${projectId}/nametag-update`, { rows: rows })
      .then((res) => res.data),
  //   Todo: res 값 재가공해야함
  fetchVoiceDropList: (projectId) =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'projectImageList',
        code: 'voice_banner',
        project_id: projectId,
      })
      .then((res) => res.data),
  // New api
  nameTagList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/nametag/${projectId}`)
      .then((res) => res.data),
  nameTagCreate: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/nametag/${projectId}`, data)
      .then((res) => res.data),
  nameTagEdit: (projectId, data) =>
    kevinAuthAPI
      .patch(`/resource-manager/nametag/${projectId}`, data)
      .then((res) => res.data),
  nameTagDelete: (projectId, speaker) =>
    kevinAuthAPI
      .delete(`/resource-manager/nametag/${projectId}?speaker=${speaker}`)
      .then((res) => res.data),
};
